import React, { useState } from 'react';
import { Handle, Position, NodeProps, useReactFlow } from '@xyflow/react';
import { Zap, X } from 'lucide-react';
import { ActionNodeData, ACTION_TYPE_OPTIONS } from '../types';

export function ActionNode({ id, data: rawData, selected }: NodeProps) {
  const data = rawData as unknown as ActionNodeData;
  const option = ACTION_TYPE_OPTIONS.find((o) => o.value === data.actionType);
  const icon = option?.icon ?? '⚡';
  const label = option?.label ?? data.actionType;
  const [isHovered, setIsHovered] = useState(false);
  const { setNodes, setEdges } = useReactFlow();

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    setNodes((nodes) => nodes.filter((n) => n.id !== id));
    setEdges((edges) => edges.filter((e) => e.source !== id && e.target !== id));
  };

  return (
    <div
      className={`relative min-w-[200px] rounded-xl border-2 bg-white shadow-lg transition-all ${
        selected ? 'border-orange-500 shadow-orange-200' : 'border-orange-400'
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete button on hover */}
      {isHovered && (
        <button
          onClick={handleDelete}
          className="absolute -top-2 -right-2 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-white shadow-md hover:bg-red-600 transition-colors"
          title="Delete node"
        >
          <X size={12} />
        </button>
      )}
      <Handle type="target" position={Position.Top} className="!bg-orange-500 !w-3 !h-3" />
      <div className="flex items-center gap-2 rounded-t-xl bg-orange-500 px-3 py-2">
        <Zap size={14} className="text-white" />
        <span className="text-xs font-semibold uppercase tracking-wider text-white">Action</span>
      </div>
      <div className="px-3 py-2">
        <p className="text-sm font-medium text-gray-800 dark:text-gray-200">
          {icon} {label}
        </p>
        {data.displaySummary && (
          <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{data.displaySummary}</p>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-orange-500 !w-3 !h-3" />
    </div>
  );
}
